var cov_2e9bg0afr8 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/styles/index.js",
      hash = "e1e321f59efbb7ce4cc96011ac6f8336b243029d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Message/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 28
        },
        end: {
          line: 7,
          column: 62
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

 // rely Alert


var messageLess = {};
import genaration from '../../utils/classname';
export var messageClass = (cov_2e9bg0afr8.s[0]++, genaration(messageLess, 'message'));